import type React from "react";
import { motion } from "framer-motion";
import { easeManor } from "../../constants/constants";

type Props = {
  label: string;
  value: string;
  hint?: string;
  delay?: number;
};

const StatTile: React.FC<Props> = ({ label, value, hint, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: easeManor, delay }}
      className="card-parchment relative px-7 py-8 rounded-sm"
    >
      <div className="absolute inset-2 border border-[color:var(--gilt-hairline)] pointer-events-none" />
      <p className="u-label">{label}</p>
      <p className="mt-4 font-display text-5xl text-[color:var(--claret-deep)] leading-none">
        {value}
      </p>
      {hint && (
        <p className="mt-3 text-sm italic text-[color:var(--ink-soft)]">{hint}</p>
      )}
    </motion.div>
  );
};

export default StatTile;
